import { useUnseenMessages } from '@application/api';
import type { Route } from '@application/types';
import { useRouter } from '@application/utils';
import type { MtLayoutNavbarLink, MtLayoutNavbarLinkCategory } from '@presentation/components';
import { useCallback } from 'react';

export const useNavbarLinkCategoriesBuyer = (): MtLayoutNavbarLinkCategory[] => {
  const { navigateToRoute, infoFromCurrentPath, translate } = useRouter();

  const navbarLinkRoute = useCallback(
    (route: Route): Partial<MtLayoutNavbarLink> => ({
      active: infoFromCurrentPath.route === route,
      onClick: () => navigateToRoute(route),
    }),
    [infoFromCurrentPath.route, navigateToRoute],
  );

  const { unseenMessagesAmount } = useUnseenMessages();

  return [
    {
      label: translate('mt.header.adoptionsTitle'),
      links: [
        {
          ...navbarLinkRoute('mtLanding'),
          label: translate('mt.header.home'),
          icon: 'home',
        },
        {
          ...navbarLinkRoute('mtApplications'),
          label: translate('mt.header.applications'),
          icon: 'list',
        },
        {
          ...navbarLinkRoute('mtWishlist'),
          label: translate('mt.header.favorites'),
          icon: 'heart',
        },
        {
          ...navbarLinkRoute('mtMessages'),
          label: translate('mt.header.messages'),
          icon: 'comments',
          notifications: unseenMessagesAmount,
        },
      ],
    },
    {
      label: translate('mt.header.animalsTitle'),
      links: [
        {
          ...navbarLinkRoute('mtAnimals'),
          label: translate('mt.header.digitalPassport'),
          icon: 'passport',
        },
        {
          ...navbarLinkRoute('mtAppointments'),
          label: translate('mt.header.appointments'),
          icon: 'calendar',
        },
      ],
    },
    {
      bottomPinned: true,
      label: translate('mt.header.followUpTitle'),
      links: [
        {
          ...navbarLinkRoute('mtPuppyGuide'),
          label: translate('mt.header.guide'),
          icon: 'list',
        },
        /*  TC-1142 - removed advantages for buyers
        {
          ...navbarLinkRoute('mtAdvantages'),
          label: translate('mt.header.advantages'),
          icon: 'gift',
        },
        */
      ],
    },
    {
      bottomPinned: true,
      links: [
        {
          ...navbarLinkRoute('mtSettings'),
          label: translate('mt.header.settings'),
          icon: 'cog',
        },
        {
          ...navbarLinkRoute('mtFaq'),
          label: translate('mt.header.faq'),
          icon: 'question',
        },
        {
          ...navbarLinkRoute('mtContact'),
          label: translate('mt.header.contact'),
          icon: 'question-circle',
        },
      ],
    },
  ];
};
